"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sendTrafficImpression = exports.sendTrafficEvent = void 0;

var sendTrafficEvent = function sendTrafficEvent(_ref) {
  var eid = _ref.eid,
      _ref$properties = _ref.properties,
      properties = _ref$properties === void 0 ? {} : _ref$properties,
      type = _ref.type;
  window._expDataLayer = window && window._expDataLayer ? window._expDataLayer : [];

  window._expDataLayer.push({
    schema: 'add_event',
    version: 'v1',
    data: {
      eid: eid,
      type: type,
      properties: properties // dom_element: domElement,
      // dom_event: domEvent,

    }
  });
};

exports.sendTrafficEvent = sendTrafficEvent;

var sendTrafficImpression = function sendTrafficImpression(_ref2) {
  var eid = _ref2.eid,
      _ref2$properties = _ref2.properties,
      properties = _ref2$properties === void 0 ? {} : _ref2$properties;
  window._expDataLayer = window && window._expDataLayer ? window._expDataLayer : [];

  window._expDataLayer.push({
    schema: 'add_impression',
    version: 'v1',
    data: {
      eid: eid,
      properties: properties // dom_element: domElement,

    }
  });
};

exports.sendTrafficImpression = sendTrafficImpression;